<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <h3>Comp-off Approval </h3>
            </div>
            <div class="edit" *ngIf="selectedCheckboxData.length > 0">
              <button type="button" title="Approve All" class="btn btn-sm" (click)="bulkUpdateStatus('Approve')">
                <div>Approve</div>
              </button>
            </div>
            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
              <button type="button" title="Reject All" class="btn btn-sm" (click)="bulkUpdateStatus('Cancel')">
                <div>Reject</div>
              </button>
            </div>
            <ag-grid-angular 
              style="height: calc(100vh - 120px) !important;" 
              class="ag-theme-material"
              (gridReady)="onGridReady($event)"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              pagination="true"
              [defaultColDef]="defaultColDef"
              [suppressRowClickSelection]="true"
              [rowSelection]="rowSelection"
              (selectionChanged)="onSelectionChanged($event)"
              paginationPageSize=10>
            </ag-grid-angular>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>

<!-- Create new Lead -->
<div class="modal fade" id="approveCompOff" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                  <div class="text-center">
                    <p>Are you sure you want to approve compensatory off?</p>
                  </div> 
                  <div class="d-flex gap-4 w-100 justify-content-around">
                    <button type="button"  class="btn btn-primary" data-bs-dismiss="modal" (click)="approvalLeave(this.userId)">Yes</button>
                    <button type="button" class="btn btn-secondary">No</button>
                  </div>
           
                </div>
            </form>
        </div>
    </div>
  </div>

  <div class="modal fade" id="cancelConfirmation" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                  <div class="text-center">
                    <p>Are you sure? do you want to delete this data?</p>
                  </div> 
                  <div class="d-flex gap-4 w-100 justify-content-around">
                    <button type="button"  class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelLeave(this.userId)">Yes</button>
                    <button type="button" class="btn btn-secondary">No</button>
                  </div>
           
                </div>
            </form>
        </div>
    </div>
  </div>

  <button type="button"  data-bs-toggle="modal" data-bs-target="#approveCompOff" id="confimationBtn" style="display: none;">
                                 
  </button>

  <button type="button"  data-bs-toggle="modal" data-bs-target="#cancelConfirmation" id="cancelConfirmationBtn" style="display: none;">
                                 
  </button>
